export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string, search: string = '') {
  const current = getCurrentUrl(pathname);

  if (!current || !url) return false;

  if (search && current + search === `/${url}`) return true;

  if (current === url || (current.indexOf(url) > -1 && !search)) {
    return true;
  }

  return false;
}

